<template>
  <div>
    <h6 class="q-mb-sm q-title">{{ $t('invite_more') }}</h6>

    <div class="row gutter-x-lg items-center">
      <q-field class="col-12 col-md" :error="errors.has('inviteEmail')" :error-label="errors.first('inviteEmail')">
        <q-input
          type="input"
          v-model.trim="invite.email"
          v-validate.disable="'required|email|max:255'"
          name="inviteEmail"
          :data-vv-as="$t('email')"
          :float-label="$t('email')"/>
      </q-field>

      <q-field class="col-12 col-md" :error="errors.has('inviteName')" :error-label="errors.first('inviteName')">
        <q-input
          v-model="invite.name"
          v-validate.disable="'max:255'"
          name="inviteName"
          :data-vv-as="$t('person_name')"
          :float-label="$t('person_name')"/>
      </q-field>

      <q-field class="col-12 col-md">
        <q-select
          type="radio"
          :options="possibleRoles"
          v-model="invite.roleId"
          :float-label="$t('role')"
        />
      </q-field>

      <div class="col-12 col-md-auto">
        <q-btn @click="handleSendInvite" color="secondary" :loading="loading" class="team-invite__add-button" outline>
          {{ $t('send_invite') }}
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import Roles from 'src/roles'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapActions } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    props: {
      team: {
        type: Object,
        required: true
      },

      allowedRoles: {
        type: Array,
        default: () => [0, 1, 2]
      }
    },

    data () {
      return {
        invite: {
          name: '',
          email: '',
          roleId: 2
        },
        loading: false
      }
    },

    computed: {
      possibleRoles () {
        return Roles.forSelect
          .filter(r => this.allowedRoles.includes(r.value))
      }
    },

    methods: {
      ...mapActions(['createTeamInvite']),

      handleSendInvite () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.loading = true

            return this.sendInvite()
          })
          .catch(error => {
            createErrorFromResponse(error)
          })
          .finally(() => {
            this.loading = false
          })
      },

      sendInvite () {
        return this.createTeamInvite({
          teamId: this.team.id,
          invite: {
            email: this.invite.email,
            name: this.invite.name,
            role_id: this.invite.roleId
          }
        })
          .then(() => {
            this.invite.email = ''
            this.invite.name = ''
          })
      }
    }
  }
</script>
